export default {
    title: 'Почни прямо зараз!',
    description: 'Створюй будь-які тендери під свої бажання та заціни як це працює',
    try: 'Спробувати',
}